export default __webpack_public_path__ + "static/banner-what-kind-of-shopper-are-you-8cdc0b6b95683c2cb4e6507ee96c5041.jpg";